{
  "page": {
    "title": "Snipe Alerts",
    "subtitle": "Get Discord DMs when items, pets, or the WoW Token you're watching appear on the auction house below your target price."
  },
  "discordRequired": {
    "title": "Discord Required",
    "description": "You need to link your Discord account before you can configure snipe alerts. Alerts are sent as Discord DMs.",
    "linkButton": "Go to Settings to Link Discord"
  },
  "loading": "Loading...",
  "notifications": {
    "title": "Snipe Notifications",
    "description": "Receive alerts when watched items or pets are found below your target price."
  },
  "alertStyle": {
    "title": "Alert Style",
    "subtitle": "Choose how Discord notifications are displayed.",
    "compact": "Compact",
    "compactDescription": "Text-only embeds, no thumbnails. More alerts per message.",
    "detailed": "Detailed",
    "detailedDescription": "Rich embeds with item thumbnails. One embed per item."
  },
  "cooldown": {
    "title": "Alert Cooldown",
    "subtitle": "How many auction house refresh cycles (about 1 hour each) to skip before re-alerting on the same auction listing. 0 = alert on every refresh.",
    "cycles": "cycle(s)",
    "save": "Save",
    "saving": "Saving..."
  },
  "realms": {
    "title": "Realms to Monitor",
    "subtitle": "Select which {{region}} realms to watch for snipe opportunities.",
    "placeholder": "Select realms to monitor",
    "removeRussian": "Remove all russian realms",
    "saveButton": "Save Realms",
    "savingButton": "Saving..."
  },
  "addEdit": {
    "addTitle": "Add Snipe {{type}}",
    "editTitle": "Edit Snipe {{type}}",
    "typeLabel": "Type",
    "typeItem": "Item",
    "typePet": "Pet",
    "typeToken": "Token",
    "typeIlvl": "ilvl",
    "itemNameLabel": "Item Name",
    "petNameLabel": "Pet Name or ID",
    "tokenLabel": "Token",
    "searchPlaceholder": "Search for an item...",
    "petPlaceholder": "Enter Pet ID (e.g. 3390) or search by name...",
    "priceLabelMin": "1g",
    "priceLabelMax": "9,999,999g 99s",
    "targetPriceLabel": "Target Price",
    "pricePlaceholder": "e.g. 500g or 500g 50s",
    "ilvlMinLabel": "Min ilvl",
    "ilvlMaxLabel": "Max ilvl",
    "optional": "(opt)",
    "sockets": "Sockets",
    "secondaryStats": "Secondary Stats",
    "secondaryStatsHint": "(optional, select up to 2)",
    "statCrit": "Crit",
    "statHaste": "Haste",
    "statVersatility": "Versatility",
    "statMastery": "Mastery",
    "noItemsFound": "No items found",
    "noPetsFound": "No pets found",
    "anyItem": "Any item",
    "addButton": "Add {{type}}",
    "updateButton": "Update {{type}}",
    "addTokenButton": "Add Token Alert",
    "updateTokenButton": "Update Token Alert",
    "cancelEdit": "Cancel Edit",
    "remove": "Remove",
    "nounItem": "item",
    "nounPet": "pet",
    "categoryLabel": "Category",
    "statSpeed": "Speed",
    "statLeech": "Leech",
    "statAvoidance": "Avoidance"
  },
  "importExport": {
    "importButton": "Import {{label}} JSON",
    "importingButton": "Importing...",
    "exportIlvlButton": "Export ilvl Items JSON",
    "exportButton": "Export {{label}} JSON",
    "clearAllButton": "Clear All {{label}} ({{count}})",
    "pasteHint": "Tip: Press Ctrl+V (or Cmd+V on Mac) anywhere on this page to paste and import a JSON file directly.",
    "clearAllTitle": "Clear All {{label}}",
    "clearAllConfirmButton": "Clear All"
  },
  "tabs": {
    "items": "Items",
    "ilvlItems": "ilvl Items",
    "pets": "Pets",
    "token": "WoW Token"
  },
  "table": {
    "filterPlaceholder": "Filter by item name or ID...",
    "countAll": "{{count}} ilvl rule(s)",
    "countFiltered": "{{filtered}} of {{total}} ilvl rules",
    "countItems": "{{count}} {{noun}}",
    "countItemsFiltered": "{{filtered}} of {{total}} {{noun}}",
    "colItems": "Items",
    "colIlvl": "ilvl",
    "colStats": "Stats",
    "colBuyout": "Buyout",
    "colActions": "Actions",
    "colTargetPrice": "Target Price",
    "editButton": "Edit",
    "duplicateButton": "Duplicate",
    "deleteButton": "Delete",
    "emptyState": "{{hint}}",
    "emptyHintItems": "Search for an item above or import a JSON file to get started.",
    "emptyHintPets": "Enter a Pet ID above or import a JSON file to get started.",
    "emptyHintToken": "Set a target price above to get notified when the WoW Token drops below it.",
    "emptyHintIlvl": "Set ilvl constraints above or import a JSON file to get started.",
    "nounItems": "item(s)",
    "nounPets": "pet(s)",
    "nounToken": "token alert",
    "nounIlvl": "ilvl rule(s)",
    "loadingName": "Loading...",
    "colCategory": "Category",
    "percentLoaded": "{{percent}}% loaded",
    "editPrice": "Edit price",
    "inlineEditHint": "Click to edit — Enter saves, Esc cancels"
  },
  "personalConfig": {
    "title": "Personal Filter Configuration",
    "subtitle": "Adjust the filters below to set your default preferences. These will be automatically applied when you use the auction tools.",
    "tip": "💡 Tip: Set your filters as you want them, then click \"Save as Defaults\" to make these your permanent settings.",
    "livePreviewTitle": "Live Filter Preview",
    "livePreviewSubtitle": "These are the actual filters from the auction tool. Set your defaults as needed:",
    "saveButton": "Save filter defaults",
    "resetToSavedButton": "🔄 Reset to My Saved Defaults",
    "resetToSystemButton": "⚙️ Reset to System Defaults",
    "needHelp": "Need help with configuration? Join our Discord",
    "dashboardSection": "Dashboard Opportunities Filter",
    "dashboardSectionSubtitle": "Set the buyout price range for items shown in the dashboard's Top Opportunities widget.",
    "dashboardBuyoutMin": "Min Buyout (Gold)",
    "dashboardBuyoutMax": "Max Buyout (Gold)",
    "dashboardBuyoutMaxHint": "Set to 0 for no maximum",
    "dashboardSaveButton": "Save Dashboard Config",
    "itemMatchingSection": "Item Key Settings",
    "itemMatchingSectionSubtitle": "Control how item variants are matched across realms when calculating opportunities.",
    "ignoreStatsBeforeExpansion": "Ignore secondary stats before this expansion",
    "ignoreStatsBeforeExpansionHint": "Items from expansions before the selected one will be treated as identical regardless of their secondary stat roll (affix). Useful for old legacy items where stat differences don't affect flip value.",
    "ignoreStatsNone": "None (disabled)",
    "itemMatchingSaveButton": "Save Item Matching Settings"
  },
  "inventoryAnalysis": {
    "premiumRequired": "You need a premium subscription active to use the tool!",
    "subscriptionRequired": "You need a subscription active to use the tool!",
    "pasteCSVFirst": "Please paste your inventory CSV data first.",
    "csvPasted": "Inventory CSV pasted.",
    "pasteHint": "Tip: Press Ctrl+V (or Cmd+V on Mac) anywhere on this page to paste your inventory CSV directly.",
    "noValidItems": "No valid items found in the CSV data. Check the format.",
    "analysisComplete": "Analysis complete! Found {{opportunities}} selling opportunities for {{items}} inventory items.",
    "analysisFailed": "Failed to analyze inventory. Please try again.",
    "title": "Inventory Analysis",
    "description": "Paste your in-game inventory CSV export below. We'll analyze each item across all available realms to find the best selling opportunities. Items are evaluated with a nominal buyout so you can see where the highest market value, historical price, and sale rates are.",
    "addonInstall": "Install the addon from",
    "addonInstallHere": "here",
    "csvFormatTitle": "Expected CSV Format",
    "csvFormatNote": "Semicolon-delimited. BonusIDs are colon-separated (e.g.",
    "csvModifiersNote": "). Modifiers use",
    "csvModifiersFormat": "type=value",
    "csvModifiersExample": "format (e.g.",
    "sellingRealmsTitle": "Selling realms for inventory",
    "suggestedDropships": "Suggested dropships",
    "inventoryDataLabel": "Inventory Data",
    "itemsDetected": "{{count}} item detected",
    "itemsDetectedPlural": "{{count}} items detected",
    "uploadFile": "Upload file",
    "analyzeButton": "Analyze {{count}} Items",
    "analyzeInventoryButton": "Analyze Inventory",
    "clearButton": "Clear",
    "backToInput": "Back to inventory input",
    "noOpportunities": "No selling opportunities found for your inventory items.",
    "noOpportunitiesReason": "This can happen if the items have no TSM market data or are not tradeable.",
    "tryAgain": "Try again",
    "exportCSV": "Export for FlipQueue"
  },
  "realmConfig": {
    "setupGuideLink": "Click here for the guide on setting up the tool",
    "selectRegion": "Select current region",
    "updateBuyingRealms": "Update buying realms for {{region}} ({{selected}} of {{total}})",
    "updateSellingRealms": "Update selling realms for {{region}} ({{selected}} of {{max}})",
    "sellingRealmLimitTooltip": "As a subscriber with a {{type}} subscription you can only select {{max}} selling realms.",
    "addAllToBuying": "Add all realms to buying realms",
    "removeAllFromBuying": "Remove all realms from buying realms",
    "removeRussianFromBuying": "Remove all russian realms from buying realms",
    "addAllToSelling": "Add all realms to selling realms",
    "removeAllFromSelling": "Remove all realms from selling realms",
    "removeRussianFromSelling": "Remove all russian realms from selling realms",
    "wowAccountsTitle": "WoW Accounts",
    "addAccount": "Add Account",
    "accountNamePlaceholder": "Account name (e.g., WoW2)",
    "accountNameRequired": "Account name is required",
    "addAccountFailed": "Failed to add account",
    "deleteAccountDefault": "Cannot delete the default account",
    "deleteAccountConfirm": "Are you sure? This account will be removed from all realm assignments.",
    "deleteAccountFailed": "Failed to delete account",
    "updateAccountFailed": "Failed to update account name",
    "assignRealmsLabel": "Assign realms to accounts (a realm can be in multiple accounts):",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "noRealmsSelected": "No realms selected",
    "addMoreAccounts": "Add more accounts to assign realms to different WoW accounts.",
    "saveButton": "Save all data",
    "missingAccountsError": "Please assign at least one account to each realm. Missing: {{realms}}",
    "discordQuestion": "Still have any question? Join our Discord",
    "navigateToFlippingTool": "Flipping Tool",
    "navigateToDropshipTool": "Dropship Tool",
    "navigateToHousingTool": "Housing Tool",
    "navigateToTSMListGenerator": "TSM List Generator",
    "saveButtonDirty": "Save changes •",
    "saveSettingsFailed": "Failed to save settings",
    "unsavedTitle": "Unsaved changes",
    "unsavedLeaveMessage": "You have unsaved realm settings. If you leave this page, your changes will be lost.",
    "unsavedLeaveConfirm": "Leave without saving",
    "unsavedStay": "Stay on page",
    "saveBeforeNavTitle": "Save your changes?",
    "saveBeforeNavMessage": "Your realm selection has unsaved changes. Save them so the tool uses your new settings.",
    "saveAndContinue": "Save & continue",
    "deleteAccountTitle": "Delete WoW account",
    "deleteAccountMessage": "Delete the account \"{{name}}\"? It will be removed from all realm assignments.",
    "deleteAccountConfirmButton": "Delete",
    "renameAccountAria": "Rename account {{name}}",
    "deleteAccountAria": "Delete account {{name}}",
    "confirmRenameAria": "Save account name",
    "cancelRenameAria": "Cancel renaming",
    "confirmAddAria": "Add account",
    "cancelAddAria": "Cancel adding account"
  },
  "tsmProfile": {
    "title": "TSM Profile Setup Guide",
    "realmPriceAnalysis": "Realm Price Analysis",
    "minimumPriceOperation": "Minimum price operation",
    "maximumPriceOperation": "Maximum price operation",
    "normalPriceOperation": "Normal price operation",
    "copyButton": "Copy",
    "copiedSuccess": "TSM {{operation}} price operation copied to clipboard!",
    "copyFailed": "Failed to copy to clipboard"
  },
  "tsmListGenerator": {
    "subscriptionRequired": "You need a subscription active to use the tool!",
    "watchVideoGuide": "Watch video guide",
    "copyTSMString": "Copy TSM String",
    "copyTSMFailed": "Failed to copy TSM string to clipboard",
    "videoGuideTitle": "TSM list generator video guide",
    "emptyTitle": "No Auction Data Found",
    "emptyDescription": "No auction data matched your configured realms. Check your realm configuration or try again after the next auction house refresh.",
    "emptyConfigureButton": "Configure Realms",
    "emptyRetryButton": "Retry"
  },
  "realmStats": {
    "subscriptionRequired": "You need a subscription active to use the tool!",
    "overallStatistics": "Overall Statistics",
    "realmPriceAnalysis": "Realm Price Analysis",
    "watchVideoGuide": "Watch video guide",
    "noData": "No realm data available",
    "legend": "Legend",
    "legendCheap": "Rather cheap (<{{ratio}})",
    "legendNormal": "Around normal ({{min}}-{{max}})",
    "legendExpensive": "Significantly expensive (>{{ratio}})",
    "tooltipCheap": "This means that items in general are closer to the regional sale average in price. Meaning it is rather cheap to buy here but not as good to sell.",
    "tooltipNormal": "This means that items are mixed in relation to the regional sale average in price. Meaning it is it can be good to buy and sell.",
    "tooltipExpensive": "This means that items in general are quite a bit higher than the regional sale average in price. Meaning it is rather expensive to buy here and might be good to sell.",
    "colRealmName": "Realm Name",
    "colPopulation": "Population",
    "colAuctions": "Auctions",
    "colPriceRatio": "Price Ratio",
    "colCheaper": "Cheaper",
    "colExpensive": "Expensive",
    "colPercentCheaper": "% Cheaper",
    "colPercentExpensive": "% Expensive",
    "colPercentEqual": "% Equal",
    "totalRealms": "Total Realms",
    "totalAuctions": "Total Auctions",
    "avgPriceRatio": "Avg Price Ratio",
    "cheaperThanRegion": "Cheaper Than Region",
    "totalAuctionsHistory": "Total Auctions History",
    "avgPriceRatioHistory": "Avg Price Ratio History",
    "percentCheaperHistory": "% Cheaper History",
    "auctionsHistory": "{{realm}} - Auctions History",
    "priceRatioHistory": "{{realm}} - Price Ratio History",
    "cheaperCountHistory": "{{realm}} - Cheaper Count History",
    "expensiveCountHistory": "{{realm}} - Expensive Count History",
    "percentCheaperRealm": "{{realm}} - % Cheaper History",
    "percentExpensiveRealm": "{{realm}} - % Expensive History",
    "percentEqualRealm": "{{realm}} - % Equal History",
    "videoTitle": "Realm stats tool video guide"
  },
  "tsmDataTable": {
    "colItemName": "Item Name",
    "colCategory": "Category",
    "colExpansion": "Expansion",
    "colSellRate": "Sell Rate",
    "colSaleAvg": "Sale Avg",
    "colRegionMarketValue": "Region Market Value",
    "colRegionHistorical": "Region Historical",
    "clickToCopy": "Click to copy: {{name}}",
    "tooltipSaleAvg": "Average price an item has sold for over the past 60 days",
    "tooltipMarketValue": "Average price an item has been posted for over the last 14 days across all realms in your region",
    "tooltipHistorical": "Average price an item has been posted for over the last 60 days across all realms in your region"
  },
  "import": {
    "confirmTitle": "Confirm Import",
    "confirmMessage": "Import {{count}} entries into the {{tab}} list?",
    "confirmMessageCategory": "Import {{count}} entries into the {{tab}} list (category: {{category}})?",
    "confirmButton": "Import"
  }
}
